import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Grow from '@mui/material/Grow';
import { fetchToken } from '../../Auth';
import { adminURL } from '../../global';

const Home = () => {
    const navigate = useNavigate();
    const [dashboards, setDashboards] = useState([]);
    const [userName,setUserName] = useState('')

    const icons = {
        'users': 'fa-solid fa-user',
        'tech': 'fa-solid fa-microchip',
        '5': 'fa-solid fa-pencil',
        '1': "fa-regular fa-file-lines",
        '3': "fa-solid fa-microphone-lines",
        '4': "fa-solid fa-headset",
        '2': "fa-solid fa-newspaper",
        'logs': "fa-solid fa-clipboard",
        '6':"fa-solid fa-link",
        'home':'fa-solid fa-house',
    }

    const customStyles = {
        item: {
          padding: '0 10px', 
        },
      };

    const fetchDashboards = async () => {
        try {
            const response = await axios.get(`/user_dashboards`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
            if (response.status === 200 && response.data) {
                setDashboards(response.data.dashboards.slice(1));
                setUserName(response.data.username)
            }
        } catch (err) {
            console.error("Error fetching dashboards:", err);
            if (err.response?.status === 401) {
                navigate(`/niyantran-panel/${adminURL}/login`);
            }
        }
    };

    useEffect(() => {
        fetchDashboards();
    }, []);

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
    };

    return (
        <section className='mt-3 container'>
            <div className='row' style={{ borderBottom: '1.4px solid #aaa' }}>
                <div style={{ borderRadius: '6px' }} className='py-3 px-2'>
                    <h3 className='bold'>Hi, {userName}!</h3>
                </div>
            </div>
            <div className='my-5 d-flex flex-column'>
                <h5 className='bold'>Quick Links</h5>
                <Carousel
                    className='w-100'
                    swipeable={true}
                    draggable={true}
                    responsive={responsive}
                    infinite={true}
                    autoPlay={false}
                    keyBoardControl={true}
                    transitionDuration={500}
                    renderButtonGroupOutside={true}
                    customStyles={customStyles}
                >
                        {dashboards.length > 0 ? (
                                dashboards.map((item, idx) => (
                                    <div key={item[0]} className='my-2 w-100 p-2'>
                                        <Grow in={true} {...(true ? { timeout: idx * 200 } : {})}>
                                            {/* <div onClick={() => navigate(item[2])}  */}
                                            <div onClick={() => (window.location.href = item[2])}

                                                className='w-100 d-flex flex-column justify-content-center align-items-center dashboard-card'
                                                style={{ height: '150px', cursor: 'pointer', borderRadius: '10px', backgroundColor: 'rgb(255, 198, 1)', color: 'white' }}>
                                                <i className={`${icons[item[0]] || 'fa-solid fa-chart-bar'} fa-2x`} style={{ color: 'white' }}></i>
                                                <h5 className='bold mt-2' style={{ color: 'white' }}>{item[1]}</h5>
                                            </div>
                                        </Grow>
                                    </div>
                                ))
                            ) : (
                                <div className='text-center w-100 p-4' style={{ backgroundColor: 'rgb(255, 198, 1)', color: 'white', borderRadius: '10px' }}>
                                    {/* <h5 className='bold'>No Dashboard Assigned</h5> */}
                                </div>
                            )}
                </Carousel>
            </div>
        </section>
    );
};

export default Home;